import { call, put, takeLatest} from 'redux-saga/effects';
import { vendorDraftList,vendorDrafSuccess } from '../actions/index.js';
import { vendorDraftProductsService } from '../services/index.js';

export function* vendorDraftProductGen() {
    const response = yield call(vendorDraftProductsService);
    if(response && response.data &&  response.data.vendorProductsList) {
      const data = yield response.data.vendorProductsList;
      yield put(vendorDrafSuccess(data));
    }
}
export function* vendorDraftProductsSaga(){
    yield takeLatest(vendorDraftList.toString(), vendorDraftProductGen);
}
